import { useStaticQuery, graphql } from "gatsby"

const ALL_AIRTABLE_REFILLS_FIELDS_QUERY = graphql`
  query {
    allAirtableallRefillsFormFields(
      filter: {
        data: {
          Show_On_Website: { eq: true }
          Product: { in: ["Updated Prescription"] }
        }
      }
    ) {
      nodes {
        data {
          Name
          Type
          Initial_Values
          Field_Names
          Module
          Show_On_Website
          Zendesk_Key
          Show_On_Zendesk
          Zendesk_Order
        }
      }
    }
  }
`

export const useAirtableRefillsFormFields = () => {
  const data = useStaticQuery(ALL_AIRTABLE_REFILLS_FIELDS_QUERY)

  return data
}
